import { Heading } from "@chakra-ui/layout";
import { H1 } from "src/typography/typography";

function PageHeading(props) {
  return <H1 {...props} />
}

export default PageHeading
